import _classCallCheck from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/SrinivasTamada/Desktop/projects/react-ionic-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { IonTabBar, IonRouterOutlet } from '../index';
var hostStyles = {
  display: 'flex',
  position: 'absolute',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  contain: 'layout size style'
};
var tabsInner = {
  position: 'relative',
  flex: 1,
  contain: 'layout size style'
};

var IonTabs =
/*#__PURE__*/
function (_Component) {
  _inherits(IonTabs, _Component);

  function IonTabs() {
    _classCallCheck(this, IonTabs);

    return _possibleConstructorReturn(this, _getPrototypeOf(IonTabs).apply(this, arguments));
  }

  _createClass(IonTabs, [{
    key: "render",
    value: function render() {
      var outlet;
      var tabBar;
      React.Children.forEach(this.props.children, function (child) {
        if (typeof child === 'object' && child.type === IonRouterOutlet) {
          outlet = child;
        }

        if (typeof child === 'object' && child.type === IonTabBar) {
          tabBar = child;
        }
      });
      return React.createElement("div", {
        style: hostStyles
      }, tabBar.props.slot === 'top' ? tabBar : null, React.createElement("div", {
        style: tabsInner,
        className: "tabs-inner"
      }, outlet), tabBar.props.slot === 'bottom' ? tabBar : null);
    }
  }]);

  return IonTabs;
}(Component);

export { IonTabs as default };